import React, { useState, useEffect } from 'react';
import PermissionPanel from './Panel';
import { TrashIcon, TrashIconDisable } from '../../../img/findcare/FindCareSVG';
import ListWithShowMoreLess from '../../common/ListWithShowMoreLess';
import MasterPermissions from 'src/Admin/api/MasterPermissions';

const PermissionFilterPanel = ({
  createUserFormData,
  onSelectedPermissionsCount,
  onSelectedPermissionLists,
  onSetAllPermissions,
  selectedPermissionsData,
  editMode,
}) => {
  const [selectedPermission, setSelectedPermission] = useState(
    selectedPermissionsData && selectedPermissionsData.length > 0
      ? selectedPermissionsData
      : createUserFormData.permissions,
  );
  const [deletePermissionId, setDeletePermissionId] = useState('');
  const [showMorePermissions, setShowMorePermissions] = useState(false);

  const editPermission = editMode
    ? MasterPermissions.CheckPermission('Edit Permission Groups')
    : true;

  const onSelectedPermissionHandler = (selectedPermissionLists) => {
    setSelectedPermission(selectedPermissionLists);
  };

  const onTrashButtonClickHandler = (permissionId) => {
    setDeletePermissionId(permissionId);
  };

  useEffect(() => {
    onSelectedPermissionsCount(selectedPermission.length);
    onSelectedPermissionLists(selectedPermission);
  }, [selectedPermission]);

  useEffect(() => {
    if (selectedPermissionsData && selectedPermissionsData.length > 0) {
      setSelectedPermission(selectedPermissionsData);
    }
  }, [selectedPermissionsData]);

  const RenderPermissionItem = ({ data, index }) => {
    const permission = data;
    return (
      <div className="selected-permission-item">
        <div className="d-flex broker-card">
          <div>
            <span className="blob-item-name-1">{permission.RoleName}</span>
          </div>
          <div className="trash-icon-div">
            {editPermission ? (
              <button
                type="button"
                className="trash-button"
                onClick={() => onTrashButtonClickHandler(permission.RoleName)}
              >
                <TrashIcon />
              </button>
            ) : (
              <button type="button" className="trash-button">
                <TrashIconDisable />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderPermissionLists = () => {
    return selectedPermission?.length ? (
      <ListWithShowMoreLess
        data={selectedPermission}
        showMore={showMorePermissions}
        setShowMore={setShowMorePermissions}
        showMoreLabel={'Permission Groups'}
        RenderItemComponent={RenderPermissionItem}
      />
    ) : null;
  };

  return (
    <>
      <PermissionPanel
        createUserFormData={createUserFormData}
        deletePermissionId={deletePermissionId}
        onSelectedPermissionHandler={onSelectedPermissionHandler}
        onSetAllPermissions={onSetAllPermissions}
        selectedPermissionsData={selectedPermissionsData}
        editPermission={editPermission}
      />
      <div className="mt-2">{renderPermissionLists()}</div>
    </>
  );
};

export default PermissionFilterPanel;
